import React, { createContext, useMemo, useCallback } from 'react';
import { useGroupStore } from '../hooks/useGroupStore';

export const GroupContext = createContext({
  groups: [],
  fetchGroups: async () => [],
  fetchGroup: async () => null,
  replaceGroup: () => {},
  upsertGroup: () => {},
  removeGroup: () => {},
  getGroup: () => null,
});

export function GroupProvider({ children }) {
  const {
    groups,
    fetchGroups,
    fetchGroup,
    upsertGroup,
    removeGroup,
    getGroup,
  } = useGroupStore();

  // Provide an alias for upsertGroup for clarity
  const replaceGroup = useCallback(
    (updatedGroup) => {
      upsertGroup(updatedGroup);
    },
    [upsertGroup]
  );

  const contextValue = useMemo(
    () => ({
      groups,
      fetchGroups,
      fetchGroup,
      upsertGroup,
      replaceGroup,
      removeGroup,
      getGroup,
    }),
    [groups, fetchGroups, fetchGroup, upsertGroup, replaceGroup, removeGroup, getGroup]
  );

  return (
    <GroupContext.Provider value={contextValue}>
      {children}
    </GroupContext.Provider>
  );
}
